import { FC } from "react"
import { Link } from "react-router-dom"
import { ExternalLink } from "lucide-react"

import { LeadLogStat } from "../../../../../../types"

interface LeadInfoCellProps {
  info: LeadLogStat
  colSpan?: number
}

const LeadInfoCell: FC<LeadInfoCellProps> = ({ info, colSpan = 1 }) => {
  const { id, name, email, phone } = info

  return (
    <td
      className="whitespace-nowrap text-sm pl-0 pr-3 md:pr-5 py-3 md:py-5 align-top"
      colSpan={colSpan}
    >
      <div className="whitespace-pre-wrap break-words">
        <div className="text-base font-medium leading-6">{name?.trim()}</div>
        <div>{email}</div>
        <div>{phone}</div>
        <div className="mt-4">
          <Link
            className="inline-flex items-center font-medium text-base text-primary-400 hover:text-primary-500 hover:underline"
            to={`/leads/${id}`}
            target="_blank"
          >
            <span className="mr-2">See full details</span>
            <ExternalLink size={14} />
          </Link>
        </div>
      </div>
    </td>
  )
}

export default LeadInfoCell
